import React from 'react';
import { clsx } from 'clsx';
import { InfoTooltip } from './InfoTooltip';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  wrapperClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', wrapperClassName = '', ...props }, ref) => {
    return (
      <div className={clsx('w-full', wrapperClassName)}>
        {label && (
          <div className="mb-1.5 flex items-center gap-1.5">
            <label htmlFor={props.id} className="text-sm font-medium text-content-secondary">
              {label}
            </label>
            {helperText && <InfoTooltip>{helperText}</InfoTooltip>}
          </div>
        )}
        <input
          ref={ref}
          className={clsx(
            'input',
            error && 'border-red-500 focus:ring-red-500',
            className
          )}
          {...props}
        />
        {error && (
          <p className="mt-1.5 text-xs text-red-500">{error}</p>
        )}
        {!label && helperText && !error && <InfoTooltip className="mt-1.5">{helperText}</InfoTooltip>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
